import React, { useState } from "react"

import { buildMutation, compress, useMutation } from "micro-graphql-react"

import ModalWithProvidedBody from "components/ModalWithProvidedBody"

const RemoveSubjectBucket = ({ subjectBucket }) => {
  const [errors, setErrors] = useState()
  const { runMutation, running } = useMutation(buildMutation(removeMutation))
  const removeBucket = closeModal => {
    runMutation({ id: subjectBucket.id })
      .then(
        response => {
          const { errorMessages } = response.subjectBucketRemove
          if (errorMessages) {
            setErrors(errorMessages)
          } else {
            closeModal()
          }
        },
        () => setErrors("Something went wrong")
      )
      .catch(() => setErrors("Something went wrong"))
  }

  return (
    <ModalWithProvidedBody
      modalTitle="Remove Bucket"
      buttonText="Remove Bucket"
      buttonClassName="btn btn-sm btn-danger"
    >
      {({ closeModal }) => (
        <>
          <div className="modal-body">
            <p className="lead">
              Are you sure? If this bucket has any subjects, they must be
              removed or moved to other buckets first.
            </p>
          </div>

          <div className="modal-footer flex-column">
            {errors && <div className="alert alert-danger w-100">{errors}</div>}
            <div className="d-flex justify-content-between w-100">
              <button className="btn btn-outline" onClick={closeModal}>
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={() => removeBucket(closeModal)}
                disabled={running}
              >
                Yes, remove it!
              </button>
            </div>
          </div>
        </>
      )}
    </ModalWithProvidedBody>
  )
}

const removeMutation = compress`
  mutation($id: ID!) {
    subjectBucketRemove(id: $id) {
      errorMessages
      subjectBucket {
        id
        tier {
          id
        }
      }
    }
  }
`

export default RemoveSubjectBucket
